import { Component, Schema, type, defaultValue } from "minecs";
@Component()
export class AirportPlane extends Schema {
    /** Operator is fixed for the current load, even when the career unlocks the airline. */
    @type("boolean")
    @defaultValue(false)
    visiting: boolean;
    @type("boolean")
    @defaultValue(false)
    boardingCalled: boolean;
    @type("number")
    @defaultValue(0)
    phase: number;
    @type("number")
    @defaultValue(0)
    clock: number;
    @type("number")
    @defaultValue(0)
    boarded: number;
    @type("number")
    @defaultValue(8)
    seats: number;
    @type("number")
    @defaultValue(101)
    flightNumber: number;
    @type("number")
    @defaultValue(0)
    gate: number;
    @type("number")
    @defaultValue(0)
    routeIndex: number;
    @type("number")
    @defaultValue(-1)
    pilot: number;
    @type("number")
    @defaultValue(1200)
    tripFrames: number;
    @type("number")
    @defaultValue(0)
    scheduleFrames: number;
    @type("number")
    @defaultValue(0)
    nextDepartureFrame: number;
    @type("number")
    @defaultValue(-1)
    plannedRoute: number;
    @type("number")
    @defaultValue(0)
    plannedSchedule: number;
    @type("number")
    @defaultValue(-1)
    scheduledDepartureFrame: number;
    @type("number")
    @defaultValue(-1)
    boardingOpensFrame: number;
    @type("number")
    @defaultValue(-1)
    scheduledArrivalFrame: number;
    @type("number")
    @defaultValue(-1)
    expectedArrivalFrame: number;
    @type("number")
    @defaultValue(0)
    departureOffset: number;
    @type("number")
    @defaultValue(0)
    arrivalOffset: number;
    @type("number")
    @defaultValue(-1)
    boardingAnnouncedFrame: number;
    @type("number")
    @defaultValue(0)
    boardingDeskFrames: number;
    @type("number")
    @defaultValue(-1)
    unattendedSince: number;
    @type("number")
    @defaultValue(0)
    aircraftReadyFrame: number;
    @type("number")
    @defaultValue(-1)
    boardingStartedFrame: number;
    @type("number")
    @defaultValue(-1)
    departureReadyFrame: number;
}
